import { BannerPromoBrand } from 'components/product/brand-create/banner-promo-brand/BannerPromoBrand'

export const BannerPromoBrandContainer = ({ brandDetail, errorForm, onChangeForm }) => {
    const copyItems = [...(brandDetail?.promotion_banners || [])]

    const setItems = (items) => {
        onChangeForm({ promotion_banners: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                mobile_image_url: null,
                desktop_image_url: null,
            },
        ])
    }

    const props = {
        items: copyItems,
        setItems,
        onChangeItem,
        onAddNewItem,
        errorForm,
    }

    return <BannerPromoBrand {...props} />
}
